import React, { useState } from "react";
import styled from "styled-components";
import {
  ArrowDropDown,
  ArrowDropUp,
  ExpandLess,
  ExpandMore,
} from "@material-ui/icons";
import { useSelector } from "react-redux";
import {getGlassCount, getSelectedAttributesMapped} from "../../reducers/project/selectors";
import content from "../../content";
import { useMobile } from "../../components/Responsive";
import Scrollbars from "react-custom-scrollbars";
import {mapCategoryToAttribute} from "../../components/Attributes/AttributesDrawer";
import {mapGlassPrice} from "../../components/Attributes/AttributesExpansion";

const Wrapper = styled.div<{ open?: boolean; desktop:boolean }>`
  height: 55px;
  display: flex;
  cursor: pointer;
  bottom: 85px;
  overflow: hidden;
  justify-content: flex-end;
  flex-direction: column;
  width: calc(100% - 20px);
  box-sizing: border-box;
  background-color: white;
  height: ${(props) => (props.open ? props.desktop? "calc(100% - 97px)" : "calc(100vh - 120px)" : "55px")};
  position: absolute;
  padding: 0px 16px;
  border: ${(props) => props.open? "1px solid rgba(0, 0, 0, 0.12)":"unset"};
  border-top: ${(props) =>
  props.open ? "unset" : "1px solid rgba(0, 0, 0, 0.12)"};
  z-index: 100;
  transition: height 0.3s ease-out;
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #080808;
  opacity: 0.8;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;
  background-color: white;
  font-size: 14px;
`;

const GridItem = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  color: #080808;
  opacity: 0.6;
  padding: 14px 0px 14px 0px;
`;

const GridItemPrice = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding: 14px 0px 14px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const ScrollbarsStyled = styled(Scrollbars)`
  & > div {
    overflow-x: hidden !important;
  }
`

const mapSelected = (selected) => {
  const array:any = []
  const arrayPrice:any = []

  selected.forEach(s => {
    if(s?.price && Number(s?.price) > 0){
      array.push(s as any)
    } else {
      arrayPrice.push(s as any)
    }
  })

  return [...array, ...arrayPrice]
}

function PriceExpander({}: IPriceExpander) {
  const [open, setOpen] = useState(false);
  const selected = useSelector(getSelectedAttributesMapped);

  const selectedAtt = mapSelected(selected)
  const glassCount = useSelector(getGlassCount)
  const mobile = useMobile();

  return (
    <Wrapper
        desktop={!mobile}
      style={
        mobile
          ? {
            bottom: "45px",
            width: "100%",
            padding: "0 24px",
            zIndex: 30000
          }
          : {}
      }
      open={open}
      onClick={() => setOpen(!open)}
    >
      <div
        style={{
          boxSizing: "border-box",
          display: "flex",
          backgroundColor: "white",
          alignItems: "center",
          height: "55px",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            marginRight: "8px",
          }}
        >
          <Label style={{marginRight:'15px'}}>{content.getValue("price")}</Label>
          <Label style={{ color: "#C41230", opacity: 1 }}>
            {selectedAtt.length === 0
              ? 0
              : selectedAtt.reduce(
                (a, b) => (Number(a) + Number(b?.price)).toFixed(2),
                ""
              )}{" "}
            {content.getValue("price_surfix")}
          </Label>
        </div>

        {open ? (
          <ExpandMore style={{ fontSize: "18px" }} />
        ) : (
          <ExpandLess style={{ fontSize: "18px" }} />
        )}
      </div>
      {open && (
        <ScrollbarsStyled autoHide={true} hideTracksWhenNotNeeded={true} autoHeight={true} autoHeightMin={'calc(100% - 40px)'} autoHeightMax={'100%'}>
        <Grid>
          {selectedAtt.map((s) => (
            <>
              <GridItem>
                <div style={{color: '#C41230'}}>{mapCategoryToAttribute(s?.category)}</div>
                {s?.name}
              </GridItem>
              <GridItemPrice>
                {(s.price && Number(s.price) > 0) ? <>{mapGlassPrice(s, glassCount)} {content.getValue("currency")}</>:<></>}
              </GridItemPrice>
            </>
          ))}
        </Grid>
        </ScrollbarsStyled>
      )}
    </Wrapper>
  );
}

export interface IPriceExpander {}

export default PriceExpander;
